import { render, staticRenderFns } from "./ValidatorTrustScore.vue?vue&type=template&id=4d1fc860&scoped=true&"
import script from "./ValidatorTrustScore.vue?vue&type=script&lang=ts&"
export * from "./ValidatorTrustScore.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorTrustScore.vue?vue&type=style&index=0&id=4d1fc860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1fc860",
  null
  
)

export default component.exports